import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  fetchUserNotifications,
  markNotificationsAsRead,
} from '@/services/notifications';
import styles from './Notifications.module.scss';
import { format } from 'date-fns';
import {
  notificationHeading,
  notificationStatuses,
  notificationStatusesText,
  notificationTypes,
} from './Notifications.constants';
import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';
import { Spinner } from 'reactstrap';
import { formatTimeFromFirestoreTimestamp } from '@/utils/timeUtils';
import { addNotification, notificationStates } from '@/components/Notification';

export const NotificationsComponent = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const authState = useSelector((state) => ({ ...state.auth }));
  const userId = authState.profile?.id;
  useEffect(() => {
    const fetchNotifications = async () => {
      const notifications = await fetchUserNotifications(userId, () => {
        setLoading(false);
      });
      (notifications ?? [])?.sort(
        (a, b) => b.createdAt.toDate() - a.createdAt.toDate()
      );
      setNotifications(notifications);
    };
    fetchNotifications();
  }, []);

  useEffect(() => {
    if (!userId) return;
    markNotificationsAsRead(userId);
  }, [userId]);
  const downloadLinkForExport = (notification) => {
    if (notification.exportStatus === notificationStatuses.COMPLETED) {
      return (
        <a
          href={notification.exportUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          (click here to download)
        </a>
      );
    }
    return null;
  };
  const getNotificationContent = (notification) => {
    switch (notification.notificationType) {
      case notificationTypes.TIMELINE_EXPORT: {
        return (
          <div className={styles.notificationHeading}>
            <Text
              fontWeight={fontWeightEnum.Medium}
              variant={textVariantsEnum.Text_md}
            >
              {notificationHeading[notification.notificationType]}
            </Text>
            <Text
              fontWeight={fontWeightEnum.Medium}
              variant={textVariantsEnum.Text_sm}
              color={'gray-600'}
            >
              Your export is{' '}
              {notificationStatusesText[notification.exportStatus]}. &nbsp;
              {downloadLinkForExport(notification)}
            </Text>
          </div>
        );
      }
      case notificationTypes.USER_ATTENDANCE_EXPORT: {
        return (
          <div className={styles.notificationHeading}>
            <Text
              fontWeight={fontWeightEnum.Medium}
              variant={textVariantsEnum.Text_md}
            >
              {notificationHeading[notification.notificationType]}
            </Text>
            <Text
              fontWeight={fontWeightEnum.Medium}
              variant={textVariantsEnum.Text_sm}
              color={'gray-600'}
            >
              Your export is{' '}
              {notificationStatusesText[notification.exportStatus]}. &nbsp;
              {downloadLinkForExport(notification)}
            </Text>
          </div>
        );
      }
    }
  };
  const renderNotifications = () => {
    if (loading) {
      return (
        <div className={styles.notificationsLoading}>
          <p className="mt-2">Loading notifications...</p>
          <Spinner color="primary" />
        </div>
      );
    }
    if (notifications.length === 0) {
      return (
        <Text
          fontWeight={fontWeightEnum.Normal}
          variant={textVariantsEnum.Text_lg}
          color={'gray-600'}
          className={styles.noNotificationsText}
        >
          No notifications.
        </Text>
      );
    }

    return (
      <div className={styles.notificationsListContainer}>
        <Text
          fontWeight={fontWeightEnum.Medium}
          variant={textVariantsEnum.Text_lg}
          color={'gray-600'}
          onClick={() => {
            addNotification({
              message: 'Preparing your export…',
              level: notificationStates.info,
              autoDismiss: 4,
            });
          }}
        >
          Notifications Page
        </Text>
        {notifications.map((notification) => (
          <div key={notification.id} className={styles.notificationItem}>
            {getNotificationContent(notification)}
            <div className={styles.notificationTime}>
              <Text
                fontWeight={fontWeightEnum.Medium}
                variant={textVariantsEnum.Text_sm}
                color={'gray-600'}
              >
                {formatTimeFromFirestoreTimestamp(notification?.createdAt)}
              </Text>
            </div>
          </div>
        ))}
      </div>
    );
  };
  return (
    <div className={styles.notificationsPage}>
      <div className={styles.notificationsListContainer}>
        {renderNotifications()}
      </div>
    </div>
  );
};
